if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();

      this.tabs = [];

      this.firstTab = null;
      this.lastTab = null;

      this.tabs = Array.from(this.querySelectorAll('[role=tab]'));
      this.tabpanels = [];
      // Map of tab => array of linked elements (outside the tabpanels) that
      // should be shown only when that tab is active.
      this.linkedElementsMap = new Map();
      this.linkedElements = [];

      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        this.tabpanels.push(tabpanel);

        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));

        // Collect any externally "linked" elements (non-tabpanel) that
        // should show/hide with this tab. Merchants can specify a comma or
        // space separated list of IDs (with or without #) via data-linked.
        var linkedAttr = tab.getAttribute('data-linked');
        if (linkedAttr) {
          var rawIds = linkedAttr
            .split(/[,\s]+/)
            .map(function (v) {
              return v.trim();
            })
            .filter(Boolean);
          var linked = [];
          for (var r = 0; r < rawIds.length; r += 1) {
            var id = rawIds[r].charAt(0) === '#' ? rawIds[r].slice(1) : rawIds[r];
            if (!id) continue;
            var el = document.getElementById(id);
            if (el) linked.push(el);
          }
          if (linked.length) this.linkedElementsMap.set(tab, linked);
        }

        if (!this.firstTab) this.firstTab = tab;
        this.lastTab = tab;
      }

      // Flatten unique linked elements for quick bulk hide.
      if (this.linkedElementsMap.size) {
        var unique = [];
        this.linkedElementsMap.forEach(function (arr) {
          for (var a = 0; a < arr.length; a += 1) {
            if (unique.indexOf(arr[a]) === -1) unique.push(arr[a]);
          }
        });
        this.linkedElements = unique;
      }

      this.setSelectedTab(this.firstTab);
    }

    setSelectedTab(currentTab) {
      // Hide all linked elements first so we don't get flicker when one is
      // shared between multiple tabs.
      if (this.linkedElements && this.linkedElements.length) {
        for (var h = 0; h < this.linkedElements.length; h += 1) {
          this.linkedElements[h].classList.add('hidden');
        }
      }

      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var isActive = currentTab === tab;
        if (isActive) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          this.tabpanels[i].classList.remove('hidden');
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          this.tabpanels[i].classList.add('hidden');
        }

        // After tab state update, if it's active show its linked elements.
        if (isActive && this.linkedElementsMap.has(tab)) {
          var linkedEls = this.linkedElementsMap.get(tab);
          for (var l = 0; l < linkedEls.length; l += 1) {
            linkedEls[l].classList.remove('hidden');
          }
        }
      }
    }

    moveFocusToTab(currentTab) {
      currentTab.focus();
    }

    moveFocusToPreviousTab(currentTab) {
      var index;

      if (currentTab === this.firstTab) {
        this.moveFocusToTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index - 1]);
      }
    }

    moveFocusToNextTab(currentTab) {
      var index;

      if (currentTab === this.lastTab) {
        this.moveFocusToTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index + 1]);
      }
    }

    onKeydown(event) {
      var tgt = event.currentTarget,
        flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          this.moveFocusToPreviousTab(tgt);
          flag = true;
          break;

        case 'ArrowRight':
          this.moveFocusToNextTab(tgt);
          flag = true;
          break;

        case 'Home':
          this.moveFocusToTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.moveFocusToTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }

  customElements.define('tabs-component', TabsComponent);
}
